// Contact details published on trustback.eu, checked 18 October 2026.
export const contactDetails = {
  email: { text: 'info@trustback.eu', href: 'mailto:info@trustback.eu' },
  consultation: { text: '+48 71 306 34 71', href: 'tel:+48713063471' },
  infoLine: { text: '+48 12 395 99 64', href: 'tel:+48123959964' },
  whatsapp: { text: '+48 72 953 21 89', href: 'https://wa.me/48729532189' },
};

export const officeDetails = [
  {
    key: 'france',
    name: { en: 'Head office · France', pl: 'Siedziba główna · Francja' },
    mode: { en: 'In-person and online support', pl: 'Obsługa stacjonarna i online' },
    identifiers: [['SIRET', '848 569 414 00016']],
    address: ['6 Pl. de la Pyramide', '92800 Puteaux, France'],
    coordinates: '48.889688, 2.237363',
    href: 'https://www.google.com/maps/place/6+Place+de+la+Pyramide,+92800+Puteaux,+France',
  },
  {
    key: 'poland',
    name: { en: 'Polish branch', pl: 'Oddział w Polsce' },
    mode: { en: 'Online support only', pl: 'Obsługa wyłącznie online' },
    identifiers: [['NIP', '7282718685'], ['KRS', '0000328162'], ['REGON', '100659960']],
    address: ['ul. Suwalska 25/27', '93-176 Łódź'],
    coordinates: '51.740315, 19.469918',
    href: 'https://www.google.com/maps?ll=51.740315,19.469918&z=14&t=m&hl=en-US&gl=US&mapclient=embed&q=Suwalska+25/27+93-176+%C5%81%C3%B3d%C5%BA',
  },
];
